module.exports = __webpack_public_path__ + "img/picto7.ab42d8f8.svg";